// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__9fbBl","title":"InfoRow_title__E1uiC"};